export default {
    num_axis_ticks: 5
}